// extracted by mini-css-extract-plugin
export default {"root":"_2AvTd","color-green":"_1OHLu","colorGreen":"_1OHLu","color-red":"_2vDyV","colorRed":"_2vDyV"};